export default __webpack_public_path__ + "static/media/discardbox_closed.44d7ddd5.png";